import { render, staticRenderFns } from "./P32SummaryReport.vue?vue&type=template&id=89270770&"
import script from "./P32SummaryReport.vue?vue&type=script&lang=js&"
export * from "./P32SummaryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports